import { combineReducers } from "redux";
import notification from "./slices/notificationSlice";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import ticket from "./slices/ticketSlice";
import outlet from "./slices/outletSlice";
import district from "./slices/districtSlice";
import product from "./slices/productSlice";
import inventory from "./slices/inventorySlice";
import category from "./slices/categorySlice";
import employee from "./slices/employeeSlice";
import role from "./slices/roleSlice";
import customer from "./slices/customerSlice";
import tax from "./slices/taxSlice";
import transaction from "./slices/transactionSlice";
import promotion from "./slices/promotionSlice";
import coupon from "./slices/couponSlice";
import couponPrivate from "./slices/couponPrivateSlice";
import other from "./slices/otherSlice";
import enumm from "./slices/enummSlice";
import report from "./slices/reportSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    notification,
    theme,
    auth,
    ticket,
    outlet,
    district,
    product,
    inventory,
    category,
    employee,
    role,
    customer,
    tax,
    transaction,
    promotion,
    coupon,
    couponPrivate,
    report,
    other,
    enumm,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
